module.exports = __webpack_public_path__ + "img/05@2x.d6461a61.png";